import { analyticsApi } from "@/api/client";

/**
 * The only event types the analytics API accepts. Sent to PostHog through
 * the external analytics API (VITE_API_ANALYTICS) via analyticsApi.track.
 */
export type CheckoutEvent =
  | "add_to_cart"
  | "remove_from_cart"
  | "products_displayed"
  | "payment_made"
  | "product_detail_request"
  | "order_placed"
  | "order_placement_errors"
  | "checkout_error";

export interface EventProperties {
  [key: string]: string | number | boolean | null | undefined;
}

/**
 * Cart add event. checkout_action distinguishes it from the remove event.
 */
export function trackCartAdd(sessionId: string, properties?: EventProperties): void {
  void analyticsApi.track({
    session_id: sessionId,
    event: "add_to_cart",
    properties: {
      checkout_action: "add_from_cart",
      ...properties,
    },
  });
}

/**
 * Cart remove event. checkout_action distinguishes it from the add event.
 */
export function trackCartRemove(sessionId: string, properties?: EventProperties): void {
  void analyticsApi.track({
    session_id: sessionId,
    event: "remove_from_cart",
    properties: {
      checkout_action: "remove_from_cart",
      ...properties,
    },
  });
}

/**
 * Error logging event.
 * errorType examples: "discount_usage", "cumi_cart_creation", "magento_cart_creation",
 * "session_creation". Pass an empty sessionId when no session exists yet.
 */
export function trackCheckoutError(
  sessionId: string,
  errorType: string,
  errorMessage: string,
  extra?: EventProperties,
): void {
  void analyticsApi.track({
    session_id: sessionId,
    event: "checkout_error",
    properties: {
      error_type: errorType,
      error_message: errorMessage,
      ...extra,
    },
  });
}
